"use client";

import { convertLetters } from "@/utils/letterConversion";

interface LeaderboardEmptyStateProps {
    message?: string;
}

const LeaderboardEmptyState: React.FC<LeaderboardEmptyStateProps> = ({
    message = "No results to display.",
}) => {
    return (
        <div className="flex flex-col items-center justify-center px-4 py-10 text-center">
            <h2 className="font-prviking text-brand text-xl sm:text-2xl">
                {convertLetters(message)}
            </h2>
        </div>
    );
};

export default LeaderboardEmptyState;
